export const formatCurrency = (amount: number): string => {
  // Format with Indian number system (e.g., 1,00,000)
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0
  }).format(amount);
};

/** Discount as percentage (0–100). Returns fee payable after discount. */
export const getDiscountedFee = (fee: number, discountPercent: number): number => {
  const percent = Math.min(Math.max(discountPercent || 0, 0), 100);
  return Math.max(Math.round(fee * (1 - percent / 100)), 0);
};

export function getCourseFeeDisplay(fee: number, discountPercent: number) {
  const percent = Math.min(Math.max(Number(discountPercent) || 0, 0), 100);
  const payable = getDiscountedFee(fee, percent);
  return {
    listPrice: fee,
    payable,
    percent,
    hasDiscount: percent > 0 && payable < fee,
  };
}

export function isCourseFree(
  fee?: number | null,
  discountPercent?: number | null,
  payable?: number | null,
  isFree?: boolean | null,
): boolean {
  if (typeof isFree === 'boolean') return isFree;
  if (typeof payable === 'number') return payable <= 0;
  if (typeof fee === 'number') return getCourseFeeDisplay(fee, discountPercent ?? 0).payable <= 0;
  return false;
}